export default "__VITE_ASSET__95vkLDtM__"